let url =
	process.env.ENVIRONMENT === 'STG'
		? 'https://svnnqvwoce.execute-api.us-east-1.amazonaws.com/dev/pomys'
		: process.env.ENVIRONMENT === 'PDN'
		? 'https://2blh4fqkq6.execute-api.us-east-1.amazonaws.com/pdn/pomys'
		: 'https://svnnqvwoce.execute-api.us-east-1.amazonaws.com/dev/pomys'

//client id and refresh tokens variables
export const REFRESH_TOKEN = `https://pomys-${
	process.env.ENVIRONMENT === 'PDN' ? 'pdn' : 'dev'
}.auth.us-east-1.amazoncognito.com/oauth2/token`
export const CLIENT_ID =
	process.env.ENVIRONMENT === 'PDN'
		? '2n4nsm3689rb7qh30l522nsc3v'
		: '5ervjfqv6pv9kmsibebmoc84jm'

//Contact us web to case variables
export const W2C_URL =
	process.env.ENVIRONMENT === 'PDN' || process.env.ENVIRONMENT === 'STG'
		? 'https://webto.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8'
		: 'https://grupofamilia--qa.my.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8'
export const W2C_ORGID =
	process.env.ENVIRONMENT === 'PDN' || process.env.ENVIRONMENT === 'STG'
		? '00D3j0000001yNQ'
		: '00D1D0000007DKH'

//MockConst
export const MockConst = 'https://api.myjson.com/bins/18rx45'

// Get ip Address
export const GET_IP_ADDRESS = 'https://api.ipify.org?format=json'

//Product
export const RATE_PRODUCT = url + '/rating/api/v1/comments/product'
export const SAVE_COMMENT = url + '/rating/api/v1/product'

// Validate username
export const VALIDATE_USERNAME = url + '/register/api/v1/validate-username'

//Account
export const LOGIN_USER = url + '/authentication/api/v1/auth'
export const RECOVERY_USER = url + '/recovery/api/v1/recovery'
export const RECOVERY_CHANGE_PASSWORD = url + '/recovery/api/v1/change-recovery'
export const GET_PROFILE_INFO = url + '/account/api/v1/profile'
export const UPDATE_PROFILE_INFO = url + '/account/api/v1/profile'
export const SEND_OTP_CODE = url + '/otp/api/v1/otp'
export const CHANGE_PASSWORD = url + '/recovery/api/v1/change'
export const GET_CHANGE_EMAIL = url + '/account/api/v1/list-email-change'
export const UPDATE_EMAIL_CHANGE = url + '/account/api/v1/update-email-change'
export const DELATE_EMAIL_CHANGE = url + '/account/api/v1/delete-email-change'
export const CONFIRM_EMAIL_CHANGE = url + '/account/api/v1/confirm-email-change'
export const SEND_OTP_NEW_EMAIL = url + '/otp/api/v1/send-otp-code-new-email'

//Register
export const REGISTER_USER = url + '/register/api/v1/user'
export const USER_CONFIRMATION = url + '/register/api/v1/user/confirmation'
export const USER_RESEND_CONFIRMATION =
	url + '/register/api/v1/user/resend-code'
export const USER_INFO_BY_CODE = url + '/register/api/v1/user/info'
export const VALIDATE_NUMBER_ID = url + '/register/api/v1/validate-number-id'

//SpokeWoman
export const GET_PARTICIPATION = url + '/competition/api/v1/participation'
export const CREATE_PARTICIPATION =
	url + '/competition/api/v1/participation/spokespersons'

//Consulting
export const CONSULTING_COMMENTS_OR_SAVE = url + '/consulting/api/v1/consult'
